import { CallCenterDetailDTO } from '../api/apiTypes.shim';

import { LocalStorageItem } from './localStorageItem';

/** @deprecated TODO use call center in authContext */
const callCenter = new LocalStorageItem<CallCenterDetailDTO>('callCenter');

/** @deprecated TODO use call center in authContext */
function callCenterId() {
  return callCenter.get()?.id || null;
}

export const CallCenterStorage = {
  /** @deprecated TODO use call center in authContext */
  callCenter,
  /** @deprecated TODO use call center in authContext */
  callCenterId
};
